import moment from "moment";

export default {
    recentChatListFormattedTimeStamp(value){
        const messageTime = moment.utc(value).local();
        const now = moment();
        const isToday = now.isSame(messageTime, 'day');
        const isYesterday = now.subtract(1, 'day').isSame(messageTime, 'day');
        const diffDays = moment().diff(messageTime, 'days');

        if (isToday){
            return messageTime.format('hh:mm A'); // Today: show time
        }else if (isYesterday){
            return 'Yesterday'; // Yesterday
        }else if (diffDays < 7){
            return messageTime.format('dddd'); // Within this week: show day name
        }else{
            return messageTime.format('D/M/YYYY hh:mm A'); // Older: show full date
        }
    },
    chatMessageFormattedTimeStamp(value){
        if (!value) return '';
        const messageTime = moment.utc(value).local();
        const now = moment();
        const diffSeconds = now.diff(messageTime, 'seconds');
        const diffMinutes = now.diff(messageTime, 'minutes');
        const diffHours = now.diff(messageTime, 'hours');
        const diffDays = now.diff(messageTime, 'days');
        if (diffSeconds < 60) {
            return 'Just now';
        } else if (diffMinutes === 1) {
            return '1 minute ago';
        } else if (diffMinutes < 60) {
            return `${diffMinutes} minutes ago`;
        } else if (diffHours === 1) {
            return '1 hour ago';
        } else if (diffHours < 24) {
            return `${diffHours} hours ago`;
        } else if (diffDays === 1) {
            return 'Yesterday';
        } else if (diffDays < 7) {
            return messageTime.format('dddd');
        } else {
            return messageTime.format('D/M/YYYY hh:mm A');
        }
    },
    truncateText(value, length = 100, clamp = '...') {
        if (!value || typeof value !== 'string') return '';
        return value.length > length ? value.slice(0, length) + clamp : value;
    }
}